export const resourceTypeOptions = [
  { value: undefined, label: 'All' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'brand', label: 'Brand' },
]
